import { FieldError, Input, Label, TextField, Group } from "react-aria-components";
import { debounce } from "../../helpers/debouncer";
import { useEffect, useState } from "react";

interface ITextField {
    value: any
    label?: string
    visibleLabel: boolean    
    icon?: any
    clickableIcon?: boolean
    IconClickEvent?: any,
    onChangeText: Function,
    onBlur?: Function,
    required?: boolean,
    className?: string,
    disabled: boolean,
    maxLength?: number,
    EnterKeyPress: any,
    validateRule?: Function,
    validationError?: string,
    placeholder?: string
    inputRef?: React.Ref<HTMLInputElement>
    autocomplete?: string
    name?: string
    type?: string
}

export default function AdobeTextField({ value, label, visibleLabel, icon, clickableIcon, IconClickEvent, onChangeText, onBlur, required, className, maxLength, EnterKeyPress, disabled = false, validateRule, validationError, inputRef, placeholder = "", autocomplete, name, type = "text" }: ITextField) {
    const [val, setVal] = useState<string>(value ?? "");
    const debouncedOnChange = debounce(onChangeText, 50);

    function handleChange(value: string) {
        setVal(value);
        debouncedOnChange(value);
    }

    function handleBlur(e: React.FocusEvent<Element, Element>) {
        if (onBlur) {
            const value = (e.target as HTMLInputElement).value;
            onBlur(value);
        }
    }

    function validate(val: string) {
        if (!required && !val) return null;
        if (validateRule) {
            return validateRule(val) ? null : validationError;
        }
    }

    useEffect(() => {
        if (value !== undefined) {
            setVal(value);
        }
    }, [value]);

    return (
        <TextField type={type} maxLength={maxLength} className={"search-field " + className} validate={(val) => validate(val)} aria-label={label} value={val ?? ""} onChange={(x) => handleChange(x)} isDisabled={disabled} onBlur={(x) => handleBlur(x)}>
            {visibleLabel && <Label className="small margin__bottom--xxs display--block">{label}{required ? " (required)" : ""}</Label>}
            
            
            {clickableIcon && (
                <Group>
                    <Input ref={inputRef} type={type} placeholder={visibleLabel && placeholder ? placeholder : label} onKeyDown={(e) => EnterKeyPress(e, val)} autoComplete={autocomplete} name={name} />
                <button className="search-icon-button" onClick={() => IconClickEvent && IconClickEvent(val)}>
                    <img src={icon} />
                </button>
                </Group>
            )}

            {!clickableIcon && (
                <Group>
                <Input ref={inputRef} type={type} placeholder={visibleLabel && placeholder ? placeholder : label} onKeyDown={(e) => EnterKeyPress(e, val)} autoComplete={autocomplete} name={name} />
                <img src={icon} />
                </Group>
            )}

            <FieldError />
        </TextField>
    );
}